import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { class: "navbar fixed-bottom navbar-dark bg-dark" }
const _hoisted_4 = { class: "container d-flex justify-content-center" }
const _hoisted_5 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_6 = { class: "btn btn-secondary" }
const _hoisted_7 = { class: "btn btn-secondary" }
const _hoisted_8 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "btn btn-light mr-auto" }
const _hoisted_11 = {
  class: "progress mx-2 w-50",
  style: {"height":"38px","background-color":"#D3D3D3"}
}
const _hoisted_12 = { style: {"padding-top":"80px","padding-bottom":"120px"} }
const _hoisted_13 = {
  id: "top",
  class: "mt-4"
}
const _hoisted_14 = { class: "font-weight-light" }
const _hoisted_15 = { class: "text-lowercase" }
const _hoisted_16 = { class: "navbar navbar-expand-md navbar-light bg-light" }
const _hoisted_17 = { class: "navbar-nav" }
const _hoisted_18 = { class: "nav-item dropdown" }
const _hoisted_19 = {
  class: "nav-link dropdown-toggle",
  id: "navbarDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = { class: "badge badge-secondary" }
const _hoisted_22 = { class: "badge badge-secondary" }
const _hoisted_23 = { class: "badge badge-secondary" }
const _hoisted_24 = { class: "badge badge-secondary" }
const _hoisted_25 = { class: "badge badge-secondary" }
const _hoisted_26 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = {
  key: 0,
  class: "m-4"
}
const _hoisted_29 = {
  key: 0,
  class: "px-2"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_33 = { class: "mt-5 mb-3 lead" }
const _hoisted_34 = { class: "text-lowercase" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-8 col-sm-12" }
const _hoisted_38 = ["id"]
const _hoisted_39 = { class: "mt-5 mb-3 lead" }
const _hoisted_40 = { class: "text-lowercase" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _component_PanelistSurveyVoteEditorDr = _resolveComponent("PanelistSurveyVoteEditorDr")!
  const _component_PanelistSurveyVoteEditorPc = _resolveComponent("PanelistSurveyVoteEditorPc")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.initialized === false)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading...", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.initialized === true)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */),
                    _createTextVNode(" Prev ", -1 /* CACHED */),
                    _createElementVNode("span", { class: "text-lowercase d-none d-sm-inline" }, "criterion", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/scoring/criterion/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}/${_ctx.prevCriterionId}`]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-warning",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
                  }, " Back to Top "),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" Next ", -1 /* CACHED */),
                    _createElementVNode("span", { class: "text-lowercase d-none d-sm-inline" }, "criterion", -1 /* CACHED */),
                    _createElementVNode("i", {
                      class: "fa fa-angle-double-right",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/scoring/criterion/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}/${_ctx.nextCriterionId}`]
                  ])
                ])
              ])
            ]),
            _createElementVNode("nav", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" My Survey ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, `/#/scoring/dashboard/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}`]
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle({'width': _ctx.progress + '%'})
                  }, _toDisplayString(_ctx.AnsweredQuestionsCount) + "/" + _toDisplayString(_ctx.questionsCount), 5 /* TEXT, STYLE */)
                ]),
                (_ctx.IsSaved == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-warning",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistVotesCommand && _ctx.handleSavePanelistVotesCommand(...args)))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Saving... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (_ctx.IsSaved === true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistVotesCommand && _ctx.handleSavePanelistVotesCommand(...args)))
                    }, " Saved "))
                  : _createCommentVNode("v-if", true),
                (_ctx.IsSaved === false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-warning",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistVotesCommand && _ctx.handleSavePanelistVotesCommand(...args)))
                    }, " Save "))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _cache[21] || (_cache[21] = _createTextVNode("Evaluate ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.alternativesLabel), 1 /* TEXT */),
                  _cache[22] || (_cache[22] = _createTextVNode(" in the context of:", -1 /* CACHED */))
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.criterionName), 1 /* TEXT */)
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
              _createElementVNode("nav", _hoisted_16, [
                _createElementVNode("ul", _hoisted_17, [
                  _createElementVNode("li", _hoisted_18, [
                    _createElementVNode("a", _hoisted_19, " Questions: " + _toDisplayString(_ctx.QuestionsFilter ?? 'All'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.QuestionsFilter = null))
                      }, [
                        _cache[23] || (_cache[23] = _createTextVNode("All ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.questionsCount), 1 /* TEXT */)
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.QuestionsFilter = 'Answered'))
                      }, [
                        _cache[24] || (_cache[24] = _createTextVNode("Answered ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.AnsweredQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.QuestionsFilter = 'Not answered'))
                      }, [
                        _cache[25] || (_cache[25] = _createTextVNode("Not answered ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.NotAnsweredQuestionsCount), 1 /* TEXT */)
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.QuestionsFilter = 'Commented'))
                      }, [
                        _cache[26] || (_cache[26] = _createTextVNode("Commented ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.CommentedQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.QuestionsFilter = 'Not commented'))
                      }, [
                        _cache[27] || (_cache[27] = _createTextVNode("Not commented ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.NotCommentedQuestionsCount), 1 /* TEXT */)
                      ])
                    ])
                  ]),
                  (_ctx.isPairwise)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                        _createElementVNode("a", {
                          class: "nav-link dropdown-toggle",
                          role: "button",
                          "data-toggle": "dropdown",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.loadConsistencyAnalysis && _ctx.loadConsistencyAnalysis(...args)))
                        }, " Most inconsistent "),
                        _createElementVNode("div", _hoisted_27, [
                          (_ctx.consistencyAnalysis == null)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, [...(_cache[30] || (_cache[30] = [
                                _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */)
                              ]))]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.consistencyAnalysis.InsufficientData === true)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, "Not enough answers to check consistency"))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.consistencyAnalysis.IsConsistent === true)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "dropdown-item",
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysisLegend && _ctx.showConsistencyAnalysisLegend(...args)))
                                    }, [
                                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "fa-stack fa-lg fa-stack-sm" }, [
                                        _createElementVNode("i", { class: "fa fa-circle fa-stack-1x text-success" }),
                                        _createElementVNode("i", { class: "fa-regular fa-face-smile fa-stack-1x" })
                                      ], -1 /* CACHED */)),
                                      _createTextVNode(" Inconsistency score: " + _toDisplayString(_ctx.consistencyAnalysis.CR) + "% ", 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.consistencyAnalysis.IsAcceptable === true)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MostInconsistent, (q) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          key: q.Id,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (_ctx.highlightQuestion(q))
                                        }, _toDisplayString(q.Name1) + " vs. " + _toDisplayString(q.Name2), 9 /* TEXT, PROPS */, _hoisted_30))
                                      }), 128 /* KEYED_FRAGMENT */)),
                                      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysisLegend && _ctx.showConsistencyAnalysisLegend(...args)))
                                      }, [
                                        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "fa-stack fa-lg fa-stack-sm" }, [
                                          _createElementVNode("i", { class: "fa fa-circle fa-stack-1x text-warning" }),
                                          _createElementVNode("i", { class: "fa-regular fa-face-meh fa-stack-1x" })
                                        ], -1 /* CACHED */)),
                                        _createTextVNode(" Inconsistency score: " + _toDisplayString(_ctx.consistencyAnalysis.CR) + "% ", 1 /* TEXT */)
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.consistencyAnalysis.IsInconsistent === true)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MostInconsistent, (q) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          key: q.Id,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (_ctx.highlightQuestion(q))
                                        }, _toDisplayString(q.Name1) + " vs. " + _toDisplayString(q.Name2), 9 /* TEXT, PROPS */, _hoisted_31))
                                      }), 128 /* KEYED_FRAGMENT */)),
                                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysisLegend && _ctx.showConsistencyAnalysisLegend(...args)))
                                      }, [
                                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "fa-stack fa-lg fa-stack-sm" }, [
                                          _createElementVNode("i", { class: "fa fa-circle fa-stack-1x text-danger" }),
                                          _createElementVNode("i", { class: "fa-regular fa-face-frown fa-stack-1x" })
                                        ], -1 /* CACHED */)),
                                        _createTextVNode(" Inconsistency score: " + _toDisplayString(_ctx.consistencyAnalysis.CR) + "% ", 1 /* TEXT */)
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("form", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control mr-sm-2",
                    type: "search",
                    placeholder: "Filter...",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.SearchPhrase]
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DirectRatesView, (dr) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: dr.Id
                }, [
                  _createElementVNode("p", _hoisted_33, [
                    _createElementVNode("strong", null, _toDisplayString(dr.OrderValue) + ".", 1 /* TEXT */),
                    _cache[36] || (_cache[36] = _createTextVNode(" How would you rate ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.ShowAlternativeDetailsCommand(dr.AlternativeName, dr.AlternativeDescription))
                    }, _toDisplayString(dr.AlternativeName), 9 /* TEXT, PROPS */, _hoisted_35),
                    _cache[37] || (_cache[37] = _createTextVNode(" in the context of ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-dark font-italic",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.ShowDetailsCommand && _ctx.ShowDetailsCommand(...args)))
                    }, _toDisplayString(_ctx.criterionName), 1 /* TEXT */),
                    _cache[38] || (_cache[38] = _createTextVNode("? ", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_PanelistSurveyVoteEditorDr, {
                        propValue: dr.Value,
                        propComment: dr.Comment,
                        propScaleLevels: _ctx.scaleLevels,
                        onUpdateValue: ($event: any) => (_ctx.updateValue(dr, $event)),
                        onUpdateComment: ($event: any) => (_ctx.updateComment(dr, $event))
                      }, null, 8 /* PROPS */, ["propValue", "propComment", "propScaleLevels", "onUpdateValue", "onUpdateComment"])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PairwiseComparisonsView, (pc) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pc.Id
                }, [
                  _createElementVNode("div", {
                    class: "row justify-content-start",
                    id: pc.DomId
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-md-8 col-sm-12", {'bg-warning': pc.Highlighted}])
                    }, [
                      _createElementVNode("p", _hoisted_39, [
                        _createElementVNode("strong", null, _toDisplayString(pc.OrderValue) + ".", 1 /* TEXT */),
                        _cache[39] || (_cache[39] = _createTextVNode(" In the context of ", -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "text-dark font-italic",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.ShowDetailsCommand && _ctx.ShowDetailsCommand(...args)))
                        }, _toDisplayString(_ctx.criterionName), 1 /* TEXT */),
                        _cache[40] || (_cache[40] = _createTextVNode(", which ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                        _cache[41] || (_cache[41] = _createTextVNode(" do you prefer: ", -1 /* CACHED */)),
                        _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "text-primary",
                          onClick: ($event: any) => (_ctx.ShowAlternativeDetailsCommand(pc.FirstAlternativeName, pc.FirstAlternativeDescription))
                        }, _toDisplayString(pc.FirstAlternativeName), 9 /* TEXT, PROPS */, _hoisted_41),
                        _cache[43] || (_cache[43] = _createTextVNode(" or ", -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "text-primary",
                          onClick: ($event: any) => (_ctx.ShowAlternativeDetailsCommand(pc.SecondAlternativeName, pc.SecondAlternativeDescription))
                        }, _toDisplayString(pc.SecondAlternativeName), 9 /* TEXT, PROPS */, _hoisted_42),
                        _cache[44] || (_cache[44] = _createTextVNode("? ", -1 /* CACHED */))
                      ]),
                      _createVNode(_component_PanelistSurveyVoteEditorPc, {
                        propValue: pc.Value,
                        propComment: pc.Comment,
                        propFirstAlternativeName: pc.FirstAlternativeName,
                        propSecondAlternativeName: pc.SecondAlternativeName,
                        onUpdateValue: ($event: any) => (_ctx.updateValue(pc, $event)),
                        onUpdateComment: ($event: any) => (_ctx.updateComment(pc, $event))
                      }, null, 8 /* PROPS */, ["propValue", "propComment", "propFirstAlternativeName", "propSecondAlternativeName", "onUpdateValue", "onUpdateComment"])
                    ], 2 /* CLASS */)
                  ], 8 /* PROPS */, _hoisted_38)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}